
import { RevButton } from '@ds/components/Button'
import { RevCardCarousel } from '@ds/components/CardCarousel'

import BuyingGuideCard from '../Card'

import translations from './Category.translations'

export default {
  components: {
    RevButton,
    BuyingGuideCard,
    RevCardCarousel,
  },
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    useNewLayout: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,
  },
}
